import { autoCapitalize } from '@/utils/autoCapitalize'
import { HistoryTypes } from './LinkedPsychologists.types'

class HistoryDataMapper {
  toDomain(persistenceData): HistoryTypes {
    return {
      stratificationBindingId:
        persistenceData?.idVinculoPacienteProfissionalEstratificacao,
      enteredUserId: persistenceData?.inseridoPorUsuarioId,
      enteredUserName: autoCapitalize(persistenceData?.nomeUsuarioInseriu),
      patientId: persistenceData?.idPaciente,
      patientName: autoCapitalize(persistenceData?.nomePaciente),
      professionalId: persistenceData?.idProfissional,
      professionalName: autoCapitalize(persistenceData?.nomeProfissional),
      bindingDate: persistenceData?.dataVinculo,
      bindingStatus: persistenceData?.flagStatusVinculado
        ? 'Vinculado'
        : 'Desvinculado',
      unbindingType: persistenceData?.tipoDesvinculo,
      unbindingDate: persistenceData?.dataDesvinculo,
    }
  }
}

export default new HistoryDataMapper()
